import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import awsconfig from "./aws-exports";
import { Amplify } from "aws-amplify";

import { UserContextProvider } from "./contexts/UserContext";
import "./App.css";
import AppRoutes from "./AppRoutes";

Amplify.configure(awsconfig);

// バックエンドAPI呼び出し用の設定
Amplify.configure({
    API: {
        endpoints: [
            {
                name: process.env.REACT_APP_API_ENDPOINT_NAME,
                endpoint: process.env.REACT_APP_API_ENDPOINT,
            },
        ],
    },
});

function App() {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <UserContextProvider>
            <Helmet>
                <html lang={currentLang} />
            </Helmet>
            <AppRoutes />
        </UserContextProvider>
    );
}

export default App;
